export default "__VITE_ASSET__B5YosKXS__"